import React from 'react'
import { ButtonGroup, Dropdown } from 'react-bootstrap'
import { HorizontalStack, TooltipPopOver } from '@ztechapps/webui.util'
import map from 'lodash/map'
import { ProductTypeEnum } from '@ztechapps/common.contract'
import type { UseProductSelectResult } from './useProductSelect'

export const ProductSelectTypeFilter = (
  args: Pick<UseProductSelectResult, 'selectedProductType' | 'setSelectedProductType'>
) => {
  const { selectedProductType, setSelectedProductType } = args

  return (
    <Dropdown as={ButtonGroup}>
      <TooltipPopOver tooltipBody={selectedProductType}>
        <Dropdown.Toggle variant="primary">{selectedProductType}</Dropdown.Toggle>
      </TooltipPopOver>
      <Dropdown.Menu align={'end'}>
        <Dropdown.Item
          onClick={() => {
            setSelectedProductType('All')
          }}
        >
          <HorizontalStack gap={1}>
            <div>All</div>
          </HorizontalStack>
        </Dropdown.Item>
        {map(ProductTypeEnum, (item, key) => {
          return (
            <Dropdown.Item
              onClick={() => {
                setSelectedProductType(item)
              }}
              key={key}
            >
              <HorizontalStack gap={1}>
                <div>{item}</div>
              </HorizontalStack>
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}
